import { render } from "./navAlertComponent.vue?vue&type=template&id=040bc674"
import script from "./navAlertComponent.vue?vue&type=script&lang=js"
export * from "./navAlertComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__